import { render } from "./systemManage.vue?vue&type=template&id=b0808f72&scoped=true"
import script from "./systemManage.vue?vue&type=script&lang=js"
export * from "./systemManage.vue?vue&type=script&lang=js"

import "./systemManage.vue?vue&type=style&index=0&id=b0808f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0808f72"]])

export default __exports__